import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Data1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 4.5H21V6H11.25V4.5ZM11.25 18H21V19.5H11.25V18ZM3 11.25H12.75V12.75H3V11.25ZM5.25 8.25C3.59315 8.25 2.25 6.90685 2.25 5.25C2.25 3.59315 3.59315 2.25 5.25 2.25C6.90685 2.25 8.25 3.59315 8.25 5.25C8.25 6.04565 7.93393 6.80871 7.37132 7.37132C6.80871 7.93393 6.04565 8.25 5.25 8.25ZM5.25 3.75C4.42157 3.75 3.75 4.42157 3.75 5.25C3.75 6.07843 4.42157 6.75 5.25 6.75C6.07843 6.75 6.75 6.07843 6.75 5.25C6.75 4.42157 6.07843 3.75 5.25 3.75ZM5.25 21.75C3.59315 21.75 2.25 20.4069 2.25 18.75C2.25 17.0931 3.59315 15.75 5.25 15.75C6.90685 15.75 8.25 17.0931 8.25 18.75C8.25 20.4069 6.90685 21.75 5.25 21.75ZM5.25 17.25C4.42157 17.25 3.75 17.9216 3.75 18.75C3.75 19.5784 4.42157 20.25 5.25 20.25C6.07843 20.25 6.75 19.5784 6.75 18.75C6.75 17.9216 6.07843 17.25 5.25 17.25ZM18.75 15C17.0931 15 15.75 13.6569 15.75 12C15.75 10.3431 17.0931 9 18.75 9C20.4069 9 21.75 10.3431 21.75 12C21.75 12.7956 21.4339 13.5587 20.8713 14.1213C20.3087 14.6839 19.5457 15 18.75 15ZM18.75 10.5C17.9216 10.5 17.25 11.1716 17.25 12C17.25 12.8284 17.9216 13.5 18.75 13.5C19.5784 13.5 20.25 12.8284 20.25 12C20.25 11.1716 19.5784 10.5 18.75 10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Data1.vue"]]);
